import type { Locale } from '@/types/dictionary';
import { get } from 'lodash';
import replaceParams from './replaceParams';
import dictionaries from '@/constants/dictionaries';

type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`;

export type TranslationKey = DotNestedKeys<Dictionaries['en']>;

export type DotNestedKeys<T> = (
  T extends object
    ? { [K in Exclude<keyof T, symbol>]: `${K}${DotPrefix<DotNestedKeys<T[K]>>}` }[Exclude<
        keyof T,
        symbol
      >]
    : ''
) extends infer D
  ? Extract<D, string>
  : never;

type Dictionaries = typeof dictionaries;

export default function getTranslations({ locale }: { locale: Locale }) {
  const dictionary = dictionaries[locale];

  function tFunction(path: TranslationKey, keys: Record<string, string> = {}): string {
    const translation = get(dictionary, path, path)!;
    return replaceParams(translation, keys);
  }

  return tFunction;
}
